import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { NgxCurrencyDirective } from 'ngx-currency';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    ReactiveFormsModule,
    NgxCurrencyDirective,
  ],
  templateUrl: './input-field.component.html',
  styleUrl: './input-field.component.css',
})
export class InputFieldComponent implements OnChanges {
  @Input() title = '';
  @Input() placeholder = '';
  @Input() value = '';
  @Input() isCurrencyField: boolean = false;
  @Input() country?: any;
  @Output() onCLose: EventEmitter<string> = new EventEmitter<string>();
  @Output() onSave: EventEmitter<string> = new EventEmitter<string>();
  maxBudget = 100000000000;
  form: FormGroup;
  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      name: [this.value, Validators.required],
    });
    this.form.get('name')?.valueChanges.subscribe((value) => {
      this.validateValue(value);
    });
  }
  validateValue(value: string | number): void {
    const numericValue =
      typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;

    if (numericValue > this.maxBudget) {
      this.form.get('name')?.setValue(this.maxBudget, { emitEvent: false });
    }
  }

  ngOnChanges() {
    this.form.get('name')?.setValue(this.value);
  }

  save() {
    const newValue = this.form.get('name')?.value;
    // console.log('Saved value:', newValue);
    this.onSave.emit(newValue);
  }

  cancel() {
    // this.form.reset({ name: this.value });
    this.onCLose.emit();
  }
}
